import * as React from "react";

// CSS
import "@/styles/components/deliveryOrderDetailCardStyles.css";

// Mui Styles
import { StyledDetailCard } from "@/styles/mui/globalStyles";

// Mui
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useCurrentAction } from "@/hooks/user";

import moment from "moment";
export default function DeliveryOrderDetailCard(props) {
  // Navigate
  // const navigate = useNavigate();
  const { deliveryOrderItem, handleOnChange } = props;
  const actions = useCurrentAction();
  return (
    <StyledDetailCard onClick={props.onClick}>
      <div className="deliveryOrderDetailContainer">
        <div className="target">
          <div>
            <Typography variant="caption" noWrap component="div">
              SI
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {deliveryOrderItem.si_number}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              員工編號
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {deliveryOrderItem.staff_code}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              員工名稱
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {deliveryOrderItem.full_name}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              運送總數
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {deliveryOrderItem.sum_of_delivery_qty}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              收貨總數
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {deliveryOrderItem.status === "InTransit" ||
              deliveryOrderItem.status === "Void"
                ? "--"
                : deliveryOrderItem.sum_of_actual_qty}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              申請時間
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {moment(deliveryOrderItem.time_created).format(
                "YYYY-MM-DD HH:mm:ss"
              )}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              收貨時間
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {deliveryOrderItem.status === "InTransit" ||
              deliveryOrderItem.status === "Void"
                ? "--"
                : moment(deliveryOrderItem.time_arrived).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )}
            </Typography>
          </div>
        </div>
        <div className="target">
          <div>
            <Typography variant="caption" noWrap component="div">
              狀態
            </Typography>
            <Select
              disabled={!actions?.updateStatus}
              labelId="status"
              id="status"
              value={deliveryOrderItem.status}
              label="狀態"
              onChange={handleOnChange}
            >
              <MenuItem value={"InTransit"}>InTransit</MenuItem>
              <MenuItem value={"Arrived"}>Arrived</MenuItem>
              <MenuItem value={"Void"}>Void</MenuItem>
            </Select>
            {/* <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {deliveryOrderItem.status}
            </Typography> */}
          </div>
        </div>
      </div>
    </StyledDetailCard>
  );
}
